import loadable from '@loadable/component';
import { LoadableFunctionalComponent } from '../../../../../../../utils/index.ts';
import { DefaultButtonLoader } from '../../../../../../../shared/index.ts';
import { ButtonViewProps } from '../../../../../types.ts';

export const DefaultButton = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.DefaultButtonComponent,
  fallback: <DefaultButtonLoader />,
}) as LoadableFunctionalComponent<ButtonViewProps>;
